import angular from 'angular';

export default function EditFindingCategoryDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  amDataService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleSaveFindingCategory = _handleSaveFindingCategory;
  vm.IsValidControl = _IsValidControl;
  vm.contentPaneIsFaded = false;
  vm.currentFindingCategoryId = 0;
  vm.newFindingCategory = { ...vm.findingCategory };

  _activate();

  // //////// METHODS //////////

  function _activate() {
    const dfdActivate = $q.defer();

    _refresh().then(() => {
      dfdActivate.resolve();
    });

    dfdActivate.promise.then(() => {
      // SSUtil.applyTooltips(angular.element('#divDialogContainer'));
    });
  }

  function _handleSaveFindingCategory() {
    _saveFindingCategory();
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.editFindingCategoryDialog);
  }

  function _saveFindingCategory() {
    const dfdSave = $q.defer();

    if ($scope.editAMFindingCategoryForm.$valid) {
      amDataService.saveFindingCategory(vm.newFindingCategory).then((response) => {
        if (!response.data) {
          alerts.error('Error occurred while saving the Finding Category.');
        } else {
          const savedFindingCategory = response.data;
          const isNew = vm.newFindingCategory.findingCategoryId <= 0;

          angular.extend(vm.newFindingCategory, savedFindingCategory);
          angular.extend(vm.findingCategory, vm.newFindingCategory);

          alerts.success('The Finding Category has been saved successfully.');

          if (isNew) {
            $rootScope.$broadcast('refreshAMFindingCategories', { auditId: vm.newFindingCategory.auditId });
          } else {
            $rootScope.$broadcast('refreshAMFindingCategory',
              { findingCategoryId: vm.newFindingCategory.findingCategoryId });
          }

          ssDialogService.hide(ssDialogService.dialogs.auditTrail.editFindingCategoryDialog);
        }
        dfdSave.resolve();
      });
    } else {
      dfdSave.reject();
    }
  }

  function _refresh() {
    vm.isProcessingComplete = false;
    const dfdRefresh = $q.defer();
    if (vm.newFindingCategory) {
      vm.currentFindingCategoryId = vm.newFindingCategory.findingCategoryId;
    }

    vm.isProcessingComplete = true;
    dfdRefresh.resolve();
    return dfdRefresh.promise;
  }

  // validation
  function _IsValidControl(ctrl) {
    return ($scope.editAMFindingCategoryForm)
      && (($scope.editAMFindingCategoryForm.$submitted && ctrl.$invalid) || (ctrl.$dirty && ctrl.$invalid));
  }
}

EditFindingCategoryDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'amDataService'
];
